//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'red'
    }
  },
  computed: {
    buttonClass () {
      const classes = [
        'tw-w-full',
        'tw-rounded-md',
        'tw-py-3',
        'tw-px-4',
        'tw-flex',
        'tw-items-center',
        'tw-justify-center',
        'tw-text-sm',
        'tw-font-semibold',

        'disabled:tw-opacity-70',
        'disabled:tw-cursor-not-allowed',

        'focus:tw-outline-none',
        'focus:tw-ring-2',
        'focus:tw-ring-offset-2',
      ]

      if (this.variant === 'red') {
        classes.push('tw-bg-red-400', 'focus:tw-ring-red-400', 'tw-text-white', 'focus:tw-ring-offset-gray-900')
      } else if (this.variant === 'latte') {
        classes.push('tw-bg-latte-300', 'focus:tw-ring-latte-300', 'tw-text-gray-900', 'focus:tw-ring-offset-white')
      } else if (this.variant === 'green') {
        classes.push('tw-bg-blue-600', 'focus:tw-ring-blue-600', 'tw-text-white', 'focus:tw-ring-offset-white')
      } else if (this.variant === 'dark') {
        classes.push('tw-bg-gray-800', 'focus:tw-ring-gray-800', 'tw-text-white', 'focus:tw-rign-offset-white')
      }

      if (this.disabled) {
        classes.push('tw-text-opacity-60')
      } else if (this.variant === 'red') {
        classes.push('hover:tw-bg-red-600', 'hover:focus:tw-ring-red-600')
      }

      return classes
    }
  }
}
